import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';

import { BehaviorScreen } from '../models/view-models/monitor-models/screen.type';
import { ScreensStateService } from '../services/screen-state/screens-state.service';
import { MonitorKey } from '../models/view-models/monitor-models/monitor-key.type';

@Pipe({
  name: 'monitorTagFilter'
})
export class MonitorTagFilterPipe implements PipeTransform {

  constructor(private screenStateService: ScreensStateService) { }

  transform(screens: BehaviorScreen[]): Observable<BehaviorScreen[]> {
    return this.screenStateService.monitorTagChanged.pipe(
      map(data => {
        let result: BehaviorScreen[];
        if (data != null) {
          const res: BehaviorScreen[] = screens.filter((item: BehaviorScreen) => _.some(data,
            new MonitorKey(item.MonitorHandler, item.MachinePhysicalAddress)));
          result = res;
        } else {
          result = screens;
        }

        if (!!!result?.length) {
          this.screenStateService.filteredMonitorsInTheDashboard.next(result);
        }

        this.screenStateService.monitorsInTheDashboard.next(result);
        return result;
      })
    );
  }
}
